export function customerIdIsValid() {
  return {
    required: { message: 'Customer Id is required' },
    validation: {
      message: 'Invalid Customer Id',
      validator: function (val: any) {
        const number = parseInt(val);
        if (_.isNaN(number) || !Number.isSafeInteger(number) || number <= 0) {
          return false;
        }

        return true;
      }
    }
  };
}

export function emailAddressIsValid(str: any) {
  // Keep this regex in sync with Boo.Utility.ValidationUtility
  return /^[\u0021-\u003f\u0041-\uffff]+@[\u0021-\u003f\u0041-\uffff]+\.[\u0021-\u003f\u0041-\uffff]{2,63}$/i.test(str);
}

export function nonNegativeIntValidationPattern() {
  /// <summary>Initializes a validation pattern where any non-negative int value is valid.</summary>
  /// <returns type="object">A new pattern for validation </returns>
  return { message: 'Must be a number greater than or equal to zero.', params: '^[0-9]*$' };
}

export function validUrlValidationPattern(isRequired?: any) {
  /// <summary>Initializes a validation pattern where any non-negative int value is valid.</summary>
  /// <returns type="object">A new pattern for validation </returns>

  const validationObject: any = {
    message: 'Must be a valid URL',
    params: '(https?):\\/\\/[^ "]+$'
  };

  if (isRequired) {
    validationObject.required = true;
  }

  return validationObject;
}